import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SKIP_GLOBAL_ERROR_TOAST } from '../helpers/http-context.tokens';

export interface SignData {
  // documentId?: string;
  pdfUrl: string;
  signatureDetail: any;
  name: string;
  esignType?: string;
  navigate?: string;
  signerIndex?: number;
  editable?: boolean;
}

export interface Signer {
  name: string;
  email: string;
  esignType: string;
  phone: string;
  signatureDetail: any[];
}

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }
  private apiUrl = '';

  getAllDocument(paramsObj?: any) {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get(`${this.apiUrl}/documents`, { params })
  }

  getDocumentDetail(id: any) {
    return this.http.get(`${this.apiUrl}/documents/${id}`);
  }

  createDocument(doc: any, templateId: string = '') {

    const formData = new FormData();

    Object.keys(doc).forEach((key) => {
      const value = doc[key];

      if (value === null || value === undefined) {
        return;
      }

      // File
      if (value instanceof File) {
        formData.append(key, value);
      }

      // Array or Object
      else if (typeof value === 'object') {
        formData.append(key, JSON.stringify(value));
      }

      // Primitive values
      else {
        formData.append(key, String(value));
      }
    });

    const url = templateId
      ? `${this.apiUrl}/documents/send/${templateId}`
      : `${this.apiUrl}/documents/send`;

    return this.http.post(url, formData, {
      context: new HttpContext().set(SKIP_GLOBAL_ERROR_TOAST, true)
    });
  }

  resendMail(docId: string) {
    return this.http.get(`/documents/resend-esign-email/${docId}`);
  }

  signDocument(data: any) {
    return this.http.post(`${this.apiUrl}/documents/${data?.id}/sign`, data);
  }

  checkDocumentStatus(documentId: string) {
    return this.http.get(`${this.apiUrl}/documents/${documentId}/status`)
  }
  documentStatusByTxn(txnId: string) {
    return this.http.get(`${this.apiUrl}/documents/document-by-txn/${txnId}`)
  }

  downloadDocument(id: any): any {
    return this.http.get(`${this.apiUrl}/documents/${id}/download`)
  }

  downloadDocumentAuditTrill(id: string) {
    return this.http.get(`/documents/${id}/audit`, {
      responseType: 'text'
    });
  }

  private _signers: Signer[] = [];

  get getSigners(): Signer[] {
    return this._signers;
  }

  set setSigners(value: Signer[]) {
    this._signers = value || [];
  }

  updateSigners(value: Signer[]): void {
    if (!this._signers || this._signers.length === 0) {
      this._signers = value || [];
      return;
    }

    value.forEach((item, index) => {
      if (this._signers[index]) {
        this._signers[index] = {
          ...this._signers[index],
          ...item
        };
      } else {
        this._signers.push(item);
      }
    });

    while (this._signers.length > value.length) {
      this._signers.pop();
    }
  }
}
